<template>
  <div class="home">
    <img
      class="main"
      alt="Index Image"
      src="https://teleportal-files.s3-ap-southeast-2.amazonaws.com/index.png"
    />
    <HelloWorld />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {
    HelloWorld
  }
};
</script>

<style scoped>
.main {
  width: 75%;
  margin: 2vw 1vw 2vw 2vw;
}

</style>